import { z } from 'zod/v4';

export const cloudProviderSchema = z.preprocess(
  (value) => (typeof value === 'undefined' || value === null ? 'AWS' : value),
  z.union([z.literal('AWS'), z.literal('Azure')])
);

export type CloudProvider = z.infer<typeof cloudProviderSchema>;
